import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { errorToast } from "../../utils";
import { reportSingleAppointment } from "../../store/appointment/appointmentActions";
import { Controller, useForm } from "react-hook-form";
import ReactSelect from "react-select";
import { FileUploader } from "react-drag-drop-files";
import { ProfileRole } from "../../store/profile/profileSlice";

const ReportEvent = ({ setIsReport, event, refreshParent }) => {

    const dispatch = useDispatch();

    const { handleSubmit, control, watch, register } = useForm()
    const [file, setFile] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleReport = (data) => {
        setIsSubmitting(true);
        let report = {id: data._id, reason: data.reason.label, more: data.more} 
        if(file){
            report.file = file
        }            
        dispatch(reportSingleAppointment(report))
        .unwrap()
        .then(v => refreshParent())
        .finally(() => setIsSubmitting(false))
    }

    const {currentProfile} = useSelector(state => state.profile)
    const IssueOptions = [
        ...(currentProfile.role == ProfileRole.TUTOR ? [
            { value: 0, label: "Student absent" },
            { value: 5, label: "Student have a technical problem" },
            { value: 6, label: "Other" },
        ]
            : currentProfile.role == ProfileRole.STUDENT ?
                [
                    { value: 0, label: "Tutor absent" },
                    { value: 5, label: "Student have a technical problem" },
                    { value: 6, label: "Other" },
                ]
                : []
        )
    ]
    const reason = watch('reason');

    const selectStyles = useMemo(() => ({
        control: (base, state) => ({
            ...base,
            minHeight: "44px",
            borderColor: state.isFocused ? "#191D51" : "#d9dde5",
            boxShadow: state.isFocused ? "0 0 0 1px #191D51" : "none",
            borderRadius: "12px",
            "&:hover": { borderColor: "#191D51" },
        }),
        menu: (base) => ({
            ...base,
            borderRadius: "12px",
            overflow: "hidden",
            zIndex: 9999,
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }), []);

    const canSubmit = Boolean(reason) && !isSubmitting;
    const fileSizeError = () => {
        errorToast("Max File Size : 5MB");
    }
    return <div className="mx-5 mb-5 rounded-2xl border border-nt-grey-light bg-white shadow-sm">
        <form className="flex flex-col gap-5 p-5" onSubmit={handleSubmit((data) => handleReport(data))}>
            <div className="border-b border-nt-grey-light pb-4">
                <h3 className="text-nt-blue text-lg font-semibold">Report Issue</h3>
                <p className="text-sm text-nt-grey mt-1">
                    Send issue details so admins can review and resolve this appointment quickly.
                </p>
            </div>
            <div className="flex">
                <div className="w-full">
                    <label className="text-xs font-semibold uppercase tracking-wide text-nt-grey mb-2 block">Reason</label>
                    <Controller
                        control={control}
                        name="reason"
                        render={({ field: { onChange, value } }) => (
                            <ReactSelect
                                className="w-full"
                                placeholder="Reason"
                                onChange={onChange}
                                value={value || ''}
                                options={IssueOptions}
                                styles={selectStyles}
                                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                menuPosition="fixed"
                            />
                        )}
                    />
                    <label className="text-xs font-semibold uppercase tracking-wide text-nt-grey mt-4 mb-2 block">More information</label>
                    <textarea
                        name="message"
                        required={(reason && reason.value == 6)}
                        {...register("more")}
                        rows={5}
                        className="w-full flex-grow border border-nt-grey-light focus:border-nt-blue focus:ring-1 focus:ring-nt-blue rounded-xl p-3 text-sm"
                        placeholder="Describe what happened (required for 'Other')."
                    ></textarea>
                    <label className="text-xs font-semibold uppercase tracking-wide text-nt-grey mt-4 mb-2 block">Attachment (optional)</label>
                    <FileUploader 
                        handleChange={(file) => setFile(file)} 
                        name="file"     
                        classes="w-full max-w-[100%] h-[100px] file-uploader rounded-xl border border-dashed border-nt-grey-light bg-slate-50"
                        maxSize={2}
                        onSizeError={() => fileSizeError()} 
                        uploadedLabel={file ? `Uploaded: ${file.name}` : "Uploaded Successfully!"} />
                    <p className="text-xs text-nt-grey mt-2">Allowed size: up to 2MB.</p>
                    <input name="_id" {...register("_id")} type="hidden" value={event._id} />
                </div>
            </div>
            <div className="flex justify-end gap-3 border-t border-nt-grey-light pt-4">
                <button
                    type="button"
                    className="w-32 bg-nt-grey text-white px-2 py-2.5 rounded-xl hover:opacity-90 transition"
                    onClick={() => setIsReport(false)}
                    disabled={isSubmitting}
                >
                    Cancel
                </button>
                <button
                    className={`w-40 text-white px-2 py-2.5 rounded-xl transition ${canSubmit ? "bg-nt-red hover:opacity-90" : "bg-nt-grey opacity-70 cursor-not-allowed"}`}
                    disabled={!canSubmit}
                >
                    {isSubmitting ? "Submitting..." : "Report"}
                </button>
            </div>
        </form>

    </div>
}
export { ReportEvent }